import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx } from "../schema"
import type {
	CreateSegmentArgs,
	DeleteSegmentArgs,
	UpdateSegmentArgs,
} from "../types"

export const segmentMutators = {
	create: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: CreateSegmentArgs
			ctx: ZeroJwtPayload
		}) => {
			// Check for type/assignment mismatch
			if (args.contactId && args.companyId) {
				throw new Error("Can't assign contact and company at the same time")
			}
			if (args.companyId && args.type !== "COMPANY") {
				throw new Error("Segment type mismatch")
			}
			if (args.contactId && args.type !== "CONTACT") {
				throw new Error("Segment type mismatch")
			}

			await tx.mutate.segments.insert({
				id: args.id,
				name: args.name,
				color: args.color,
				type: args.type,
				createdAt: Date.now(),
				updatedAt: Date.now(),
				isDeleted: false,
				version: 1,
				workspaceId: authData.workspaceId,
			})

			// Add relationships
			if (args.companyId) {
				await tx.mutate.companyToSegments.insert({
					A: args.companyId,
					B: args.id,
				})
			}

			if (args.contactId) {
				await tx.mutate.contactToSegments.insert({
					A: args.contactId,
					B: args.id,
				})
			}
		},
	),
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateSegmentArgs }) => {
			await tx.mutate.segments.update(args)
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: DeleteSegmentArgs }) => {
			// Soft delete by setting isDeleted: true
			await tx.mutate.segments.update({
				id: args.id,
				isDeleted: true,
			})
		},
	),
}
